import React,{useState} from 'react';
import { motion } from 'framer-motion';
import './Hero.css';
import QuoteForm from './QuoteForm';

const Hero = () => {
  const [formOpen, setFormOpen] = useState(false);
  return (
    <>
    <section style={{ backgroundImage:`url('./images/displaypic.JPG')`}} className="hero">
      <div className="glass">
        <motion.h1 
          className="headline"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
        >
          <span className="highlight">Energise</span> Your Decor
        </motion.h1>
{/* 
        <motion.p 
          className="subtitle"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.7 }}
        >
          Elevate your  living space with timeless elegance and modern furniture.
        </motion.p> */}

        <motion.div 
          className="buttons"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        ><motion.button
        className="btn primary"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        animate={{
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          repeatType: 'loop',
          ease: 'easeInOut',
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setFormOpen(true);
        }}
        onTouchStart={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setFormOpen(true);
        }}
      >
        Get A Quote
      </motion.button>

          <motion.button
            className="btn secondary"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={{ type: 'spring', stiffness: 300 }}
          >
            Learn More
          </motion.button>
        </motion.div>       
      </div>     
    </section>   
    <QuoteForm  
     
     title="Get a Quick Quote"
     subtitle="Share a few details and our design team will get in touch with your quote."
     isOpen={formOpen}
      onClose={() => setFormOpen(false)} />
    </>
  );
};

export default Hero;
